import { $api } from "../generated/client";

/** Entries of the "add a carrier" picker for the current viewer (BBS-429). */
export const useCarrierCatalogQuery = (shopId: string) => {
  return $api.useQuery("get", "/shops/{shopId}/carriers/catalog", {
    params: { path: { shopId } },
  });
};
